/* created by CoolGuy on 2019/1/27 */
import React, { Component, useEffect, useState } from "react";

import ajaxUtil from "@/util/ajax";
import AjaxAction from "../../actions/AjaxAction";

const { ajax } = ajaxUtil;
// 使用这个HOC请在他的上层connect userList (state.asyncUserList)进来
//高阶组件定义
export default (WrappedComponent) =>
  class WrapperComponent extends Component {
    findUserById = (id) => {
      let { userList = [] } = this.props;
      if (userList[id]) {
        return userList[id].nickname || "--";
      } else {
        // try {
        //     var exist = window.localStorage.getItem(`user${id}`);
        //     if(exist) {
        //         exist = JSON.parse(exist);
        //         if(exist && exist.nickname) {
        //             if(exist.expires > Date.now()) {
        //                 return exist.nickname || '--';
        //             }
        //         }
        //     }
        // }catch(e) {}
        let { dispatch } = this.props;
        id && dispatch(AjaxAction.userOneAsync(id));
        return "加载中";
      }
    };

    findUserByIdPromise = async (id) => {
      let { userList = [] } = this.props;
      if (userList[id]) {
        return userList[id].nickname || "--";
      } else {
        // try {
        //     var exist = window.localStorage.getItem(`user${id}`);
        //     if(exist) {
        //         exist = JSON.parse(exist);
        //         if(exist && exist.nickname) {
        //             if(exist.expires > Date.now()) {
        //                 return exist.nickname || '--';
        //             }
        //         }
        //     }
        // }catch(e) {}
        let { dispatch } = this.props;
        let result = await dispatch(AjaxAction.userOneAsync(id));
        console.log(result);
        return result.nickname;
      }
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          findUserById={this.findUserById}
          findUserByIdPromise={this.findUserByIdPromise}
        />
      );
    }
  };

const cachedUserMap = {};
export const useUserName = (userId, userMap = cachedUserMap) => {
  const [userName, setUserName] = useState("");
  useEffect(() => {
    if (!userId) {
      setUserName("--");
      return;
    }
    if (userMap[userId]) {
      setUserName(userMap[userId].nickname || "--");
    } else {
      ajax({
        url: `/api/user/${userId}`,
        method: "GET",
      }).then((result) => {
        userMap[userId] = result;
        setUserName(result.nickname || "加载中...");
      });
    }
  }, [userId]);

  return userName;
};



// WEBPACK FOOTER //
// ./src/components/Order/FindUserHOC.js